import { render, staticRenderFns } from "./AltSidebar.vue?vue&type=template&id=00e6c1d2&scoped=true"
import script from "./AltSidebar.vue?vue&type=script&lang=js"
export * from "./AltSidebar.vue?vue&type=script&lang=js"
import style0 from "./AltSidebar.vue?vue&type=style&index=0&id=00e6c1d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e6c1d2",
  null
  
)

export default component.exports